<div class="flex bg-(--comp-input-bg-file) gap-4 justify-center flex-col md:flex-row w-full">
  @if (
    formControlGeneral?.enabled &&
    formControlGeneral?.value.length == 0 &&
    (!AdditionalValuesFiles.systemFileName || !AdditionalValuesFiles.fileName)
  ) {
    <div class="flex flex-col w-full">
      <label
        [ngClass]="
          formControlGeneral?.invalid && (formControlGeneral?.touched || formControlGeneral?.dirty)
            ? 'text-(--comp-input-label-error)!'
            : ''
        "
        class="w-full"
        (click)="activateFormFileErrors()"
        (dragover)="handleDragOver($event)"
        (drop)="handleDrop($event)"
        [attr.accept]="accept"
      >
        <div
          class="border-2 rounded-md border-dashed border-(--comp-input-file-border) p-3 pb-0! cursor-pointer flex h-18! flex-col"
        >
          <div
            class="w-full h-full text-center text-sm font-semibold justify-between flex items-center gap-4 mt-1"
          >
            <div
              class="w-full text-(--comp-input-file-text)!"
              [ngClass]="
                formControlGeneral?.invalid &&
                (formControlGeneral?.touched || formControlGeneral?.dirty)
                  ? 'text-(--comp-input-label-error)!'
                  : ''
              "
            >
              {{ isRequired(formControlGeneral) ? (label | translate) + '*' : (label | translate) }}
            </div>
            <div
              class="rounded-full border-2 border-(--comp-input-icons-file) size-8 flex shrink-0! items-center justify-center"
            >
              <mat-icon class="material-symbols-outlined text-(--comp-input-icons-file)!"
                >upload</mat-icon
              >
            </div>
          </div>
          <input
            [accept]="accept"
            style="display: none"
            type="file"
            (change)="fileInputLight($event)"
          />
          <div class="h-4 shrink-0!">
            @if (formControlGeneral?.hasError('required')) {
              <div class="mat-error h-4!">{{ 'inputs.required' | translate }}</div>
            }
            @if (formControlGeneral?.hasError('maxlength')) {
              <div class="mat-error h-4!">
                {{
                  'inputs.max'
                    | translate: { max: formControlGeneral?.errors!['maxlength'].requiredLength }
                }}
              </div>
            }
            @if (formControlGeneral?.hasError('minlength')) {
              <div class="mat-error h-4!">
                {{
                  'inputs.min'
                    | translate: { min: formControlGeneral?.errors!['minlength'].requiredLength }
                }}
              </div>
            }
            @if (formControlGeneral?.errors?.['errorGeneral']) {
              <div class="mat-error h-4!">
                {{ formControlGeneral?.errors?.['errorGeneral'] }}
              </div>
            }
          </div>
        </div>
      </label>
    </div>
  } @else if (
    this.formControlGeneral?.disable &&
    formControlGeneral?.value.length == 0 &&
    (!AdditionalValuesFiles.systemFileName || !AdditionalValuesFiles.fileName)
  ) {
    <label>
      <div
        class="button-general opacity-50 flex justify-center items-center text-base h-18! mb-4"
        mat-raised-button
      >
        {{ label | translate }}
        <input [accept]="accept" style="display: none" />
      </div>
    </label>
  }

  @if (
    formControlGeneral?.value.length ||
    AdditionalValuesFiles.systemFileName ||
    AdditionalValuesFiles.fileName
  ) {
    <div class="w-full">
      <div
        class="rounded-xl border border-(--comp-input-file-border) justify-around shadow-xl inset-shadow-sm flex p-3 gap-2 h-18! overflow-hidden"
        matButton
      >
        <div class="flex justify-center gap-1">
          <button
            matFab
            [attr.aria-label]="'common.actions.download' | translate"
            class="bg-(--comp-input-file-border)! rounded-xl! size-12!"
            (click)="downloadFile(0)"
          >
            <div
              class="rounded-full border-2 border-(--comp-input-icons-file) size-8 flex shrink-0! items-center justify-center m-auto!"
            >
              <mat-icon class="material-symbols-outlined text-(--comp-input-icons-file)!"
                >download</mat-icon
              >
            </div>
          </button>

          <div class="flex items-start justify-center w-auto text-sm font-semibold flex-col gap-1">
            <!-- 📱 Mobile (hasta 639px) -->
            <div
              class="px-5 text-(--comp-input-text)! block sm:hidden"
              [matTooltip]="AdditionalValuesFiles.fileName"
              matTooltipPosition="above"
            >
              {{ (AdditionalValuesFiles ? AdditionalValuesFiles.fileName : '') | slice: 0 : 20
              }}{{
                AdditionalValuesFiles.fileName && AdditionalValuesFiles.fileName.length > 20
                  ? '...'
                  : ''
              }}
            </div>
            <div
              class="px-5 text-(--comp-input-text)! sm:block hidden md:hidden"
              [matTooltip]="AdditionalValuesFiles.fileName"
              matTooltipPosition="above"
            >
              {{ (AdditionalValuesFiles ? AdditionalValuesFiles.fileName : '') | slice: 0 : 30
              }}{{
                AdditionalValuesFiles.fileName && AdditionalValuesFiles.fileName.length > 30
                  ? '...'
                  : ''
              }}
            </div>

            <!-- 💻 Desktop (640px - 1536px) -->
            <div
              class="px-5 text-(--comp-input-text)! hidden md:block xl:hidden"
              [matTooltip]="AdditionalValuesFiles.fileName"
              matTooltipPosition="above"
            >
              {{ (AdditionalValuesFiles ? AdditionalValuesFiles.fileName : '') | slice: 0 : 20
              }}{{
                AdditionalValuesFiles.fileName && AdditionalValuesFiles.fileName.length > 20
                  ? '...'
                  : ''
              }}
            </div>

            <!-- 💻 Desktop (1536px+) -->
            <div
              class="px-5 text-(--comp-input-text)! hidden xl:block"
              [matTooltip]="AdditionalValuesFiles.fileName"
              matTooltipPosition="above"
            >
              {{ (AdditionalValuesFiles ? AdditionalValuesFiles.fileName : '') | slice: 0 : 55
              }}{{
                AdditionalValuesFiles.fileName && AdditionalValuesFiles.fileName.length > 55
                  ? '...'
                  : ''
              }}
            </div>
            <div class="h-4 flex justify-center">
              <a matButton (click)="getFileLigh(0)" target="_blank" class="font-bold h-4! px-1!">{{
                'common.actions.view' | translate
              }}</a>

              <!-- 📱 Mobile (hasta 639px) -->
              <mat-label
                class="text-[12px] h-4! pt-0.5 text-(--comp-input-label-normal)! block sm:hidden"
                [matTooltip]="label"
                matTooltipPosition="above"
              >
                {{ (label ? label : '') | slice: 0 : 18
                }}{{ label && label.length > 18 ? '...' : '' }}
              </mat-label>

              <mat-label
                class="text-[12px] h-4! pt-0.5 text-(--comp-input-label-normal)! sm:block hidden md:hidden"
                [matTooltip]="label"
                matTooltipPosition="above"
              >
                {{ (label ? label : '') | slice: 0 : 30
                }}{{ label && label.length > 30 ? '...' : '' }}
              </mat-label>

              <!-- 💻 Desktop (640px - 1536px) -->
              <mat-label
                class="text-[12px] h-4! pt-0.5 text-(--comp-input-label-normal)! hidden md:block xl:hidden"
                [matTooltip]="label"
                matTooltipPosition="above"
              >
                {{ (label ? label : '') | slice: 0 : 20
                }}{{ label && label.length > 20 ? '...' : '' }}
              </mat-label>

              <!-- 💻 Desktop (1536px+) -->
              <mat-label
                class="text-[12px] h-4! pt-0.5 text-(--comp-input-label-normal)! hidden xl:block"
                [matTooltip]="label"
                matTooltipPosition="above"
              >
                {{ (label ? label : '') | slice: 0 : 40
                }}{{ label && label.length > 40 ? '...' : '' }}
              </mat-label>
            </div>
          </div>
        </div>

        <div
          class="rounded-full border-2 border-(--comp-input-icons-file) size-8 shrink-0! items-center justify-center my-auto! hidden sm:flex"
        >
          <button
            mat-icon-button
            [attr.aria-label]="'common.actions.delete' | translate"
            (click)="openModalDelete(0)"
          >
            <mat-icon class="material-symbols-outlined text-(--comp-input-icons-file)!"
              >delete</mat-icon
            >
          </button>
        </div>
      </div>
    </div>
  }
</div>

<app-load-general [load]="load"></app-load-general>
